export default {
  row: {
    display: 'flex',
    gap: '20px',
  },
};
